var map = {
	"./altf/sleeping-bot-avatar.png": "120a",
	"./datarmony/sleeping-bot-avatar.png": "e10c",
	"./default/sleeping-bot-avatar.png": "7fa0",
	"./euruni/sleeping-bot-avatar.png": "2bfc",
	"./foundever/sleeping-bot-avatar.png": "1cc6",
	"./gala/sleeping-bot-avatar.png": "5279",
	"./ie/sleeping-bot-avatar.png": "7a27",
	"./sitel-learning-sandbox/sleeping-bot-avatar.png": "f015",
	"./sitel-learning/sleeping-bot-avatar.png": "2d6a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5456";